export class BusMessages{
    static SubmittedForPrinting = "submittedforprinting";
    static Printed = "printed";
}